import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/sentry"; // Init Sentry first (no-op if DSN env var is absent)
import App from "@/App";

// Force dark theme
document.documentElement.classList.add("dark");

// Quota responses (HTTP 402) are handled by the global QuotaModal listener.
// Suppress CRA's red runtime error overlay for these intentional rejections.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    const status = e?.reason?.response?.status;
    if (status === 402) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (production AND preview, but not localhost dev)
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Auto-refresh when a new SW activates (avoids stuck-on-old-version)
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "activated" && navigator.serviceWorker.controller) {
              // A new version took control — reload once to apply.
              window.location.reload();
            }
          });
        });
        // Periodic check for updates (every 60min while tab is open)
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch(() => {/* silent — PWA is progressive enhancement */});
  });
}
